import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable } from 'mobx';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
export var PageInfoStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(PageInfoStore, _BaseStore);

  function PageInfoStore() {
    var _this;

    _classCallCheck(this, PageInfoStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PageInfoStore).apply(this, arguments));
    /** Store name */

    _this.name = StoreName.PageInfo;
    _this.errorStore = _this.rootStore.getStore(StoreName.Error);
    return _this;
  }
  /**
   *
   * @param title Page title and header title of current page
   * @param keywords Current page keywords
   * @param lang Current page language
   * @param description Current page description
   */


  _createClass(PageInfoStore, [{
    key: "updatePageInfo",
    value: function updatePageInfo(title, keywords, lang, description) {
      this.title = title;
      this.keywords = keywords;
      this.lang = lang;
      this.description = description;
    }
  }]);

  return PageInfoStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", String)], PageInfoStore.prototype, "title", void 0);

__decorate([observable, __metadata("design:type", String)], PageInfoStore.prototype, "keywords", void 0);

__decorate([observable, __metadata("design:type", String)], PageInfoStore.prototype, "lang", void 0);

__decorate([observable, __metadata("design:type", String)], PageInfoStore.prototype, "description", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String, String, String, String]), __metadata("design:returntype", void 0)], PageInfoStore.prototype, "updatePageInfo", null);